Librarian.Modules.RecentFilesLinks = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["viewAll", "getCustomData", "clickHandler"],

    options: {
        classPrefix: "modules-recentfileslinks-",
        label: null,
        importDate: null,
        viewOption: null,
        excludeCategory: null,
        catType: Librarian.catType.file,
        action: "preview" // "download", or "preview"
    },

    initialize: function (options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function () {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();

        if (!this.containerEl) {
            return;
        }

        if (this.options.isSquare) {
            // add view all button
            new Element("span", {
                "class": "viewAll",
                events: {
                    click: this.viewAll
                },
                text: Librarian.Lang.getString("homepage_viewall"),
                "data-translation": "homepage_viewall"
            }).injectInside(this.wrapperEl);
        }

        Librarian.Utils.getNewestFiles(7, function (response) {
            response.data.forEach(function (file) {
                if (self.options.nameMeta)
                    var name = file.extrafields[self.options.nameMeta] || file.name;
                else
                    var name = file.name;
                var linkEl = new Element("div", {
                    "class": "file-link",
                    events: {
                        click: function (event) {
                            self.clickHandler(event, file);
                        }
                    }
                }).injectInside(self.containerEl);

                new Element("img", {
                    "class": "file-link-icon",
                    src: Librarian.Utils.getContentTypeIcon(file)
                }).injectInside(linkEl);

                new Element("span", {
                    "class": "file-link-text",
                    text: name,
                    title: name
                }).injectInside(linkEl);

                if (self.options.importDate == "true") {
                    linkEl.addClass("date");

                    new Element("div", {
                        "class": "file-link-date",
                        text: Librarian.Utils.extractDateFromString(file.importdate).format("%m/%d/%y")
                    }).injectInside(linkEl);
                }
            });
        }, null, null, null, true, self.getCustomData);
    },

    clickHandler: function (event, file) {
        event.stopPropagation();

        if (this.options.action === "preview") {
            Librarian.PreviewWindow.openPreviewWindow(file);
        }

        else if (this.options.action === "open") {
            var url = '#';

            // Build the url from the data we have
            if (file.fileid > 0)
                url += "fileid=" + file.fileid;
            else if (file.groupid > 0)
                url += "groupid=" + file.groupid;

            // Including the cat ID if we have it
            if (file.extrafields && file.extrafields.CatID != null)
                url += "&catid=" + file.extrafields.CatID;
            else if (file.catid > 0)
                url += "&catid=" + file.catid;

            // And set that as the url for this link
            document.location.href = url + "&type=" + this.options.catType;
        }
    },

    viewAll: function () {
        Librarian.ContentLists.showNewestFiles();
    },

    getCustomData: function (data, url) {
        var resultOptions = {
            data: {},
            url: url
        };

        if ((typeof Library.getSendData == "function")) {
            var sendData = Library.getSendData(data, url);

            if (sendData != null) {
                resultOptions = sendData;
            }
        }

        if (this.options.excludeCategory != null) {
            if (!resultOptions.url.contains("in=ujson")) {
                resultOptions.url += "&in=ujson";
            }

            resultOptions.data.ExcludeFields = {
                "FilePath": this.options.excludeCategory
            }
        }

        if (this.options.params != null) {
            resultOptions.url += "&" + Object.toQueryString(this.options.params);
        }

        return resultOptions;
    }
});